<template lang="pug">
  .box
    VueApexCharts(
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    )
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  import { roundToK, roundToTwo } from '@/utils/helper'

  export default {
    name: 'TotalMRRChart',

    components: {
      VueApexCharts
    },

    props: {
      data: {
        type: Array
      },
      ratio: {
        type: Number
      }
    },

    data () {
      return {}
    },

    computed: {
      multiplier () {
        return  (100 + this.ratio) / 100
      },

      series () {
        return [
          {
            name: 'MRR',
            type: 'column',
            data: this.data.slice(1).map(d => d.total_mrr.total)
          },
          {
            name: 'Hedef',
            data: this.data.slice(0, 12).map(d => d.total_mrr.total * (100 + this.ratio) / 100),
            type: 'column'
          },
          {
            name: 'Tahmini Büyüme (%' + roundToTwo(this.ratio) + ')',
            data: this.data.slice(0, 12).map((d, idx) => this.data[0].total_mrr.total * Math.pow(this.multiplier, idx + 1)),
            type: 'line'
          },
        ]
      },


      chartOptions () {
        let min1 = Math.min(...this.series[0].data)
        let min2 = Math.min(...this.series[1].data)

        min1 = min1 > min2 ? min2 : min1
        if (min1 > 2000) {
          min1 -= 1000
        }

        let min = 0 // Math.floor(min1)

        return {
          chart: {
            height: 350,
            type: 'bar',
          },
          title: {
            text: "MRR Hedef",
            align: 'left',
            margin: 10,
          },
          labels: this.data.slice(1).map(d => d.stat_date),
          colors: ["#1DE4BD", "#19AADE", "#0075FF"],
          fill: {
            opacity: [1, 0.70],
          },
          stroke: {
            width: 3,
            curve: 'straight',
            dashArray: 8
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '70%',
            }
          },
          dataLabels: {
            enabled: false,
            offsetY: -13,
            formatter: function (val) {
              return "₺ " + roundToK(val)
            },
            style: {
              colors: ['white']
            },
            background: {
              enabled: true,
              foreColor: '#001f3f',
              padding: 2,
              borderRadius: 2,
              borderWidth: 1,
              borderColor: '#001f3f',
              opacity: 1
            },
          },
          yaxis: {
            min: min,
            labels: {
              formatter: val => {
                return "₺ " + roundToK(val)
              },
              offsetX: -10
            }
          },
          xaxis: {
            tickPlacement: 'between',
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: false,
            }
          },
          tooltip: {
            shared: true,
          },
        }
      }
    },

    methods: {}

  }
</script>

<style lang="scss" scoped>
</style>
